import { ClearOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Select } from "antd";
import React from "react";
import { FileUploadsJobFilters } from "../../../../Interface";

interface FileUploadsFilterMenuProps {
  handleFileUploadClick: () => void;
  handleFilterChange: (
    key: keyof FileUploadsJobFilters,
    value: any | null
  ) => void;
  clearFilters: () => void;
  filters: FileUploadsJobFilters;
}

const filterOptions = [
  {
    value: "pending",
    label: "Pending",
  },
  {
    value: "failed",
    label: "Failed",
  },
  {
    value: "completed",
    label: "Completed",
  },
];

const failureReasonOptions = [
  {
    value: "application.limit.reached",
    label: "Application Limit Reached",
  },
  {
    value: "application.already.exists",
    label: "Application Already Exists",
  },
  {
    value: "failed.to.extract.user.details",
    label: "Failed to Extract User Details",
  },
  {
    value: "invalid.file.format",
    label: "Invalid File Format",
  },
  {
    value: "unable.to.process.resume",
    label: "Unable to Process Resume",
  },
];

const sortOptions = [
  {
    value: "latest_first",
    label: "Latest First",
  },
  {
    value: "oldest_first",
    label: "Oldest First",
  },
];

const FileUploadsFilterMenu: React.FC<FileUploadsFilterMenuProps> = ({
  handleFileUploadClick,
  handleFilterChange,
  clearFilters,
  filters,
}) => {
  const handleStatusFilter = (value: string | undefined) => {
    handleFilterChange("status", value || null);
  };

  const handleFailureReasonFilter = (value: string | undefined) => {
    handleFilterChange("failureReason", value || null);
  };

  const handleSortFilter = (value: string | undefined) => {
    handleFilterChange("sort", value || null);
  };

  return (
    <div className="file-uploads-filter-menu">
      <Select
        placeholder="Filter by Status"
        options={filterOptions}
        size="middle"
        onChange={handleStatusFilter}
        value={filters.status}
        allowClear
      />
      <Select
        placeholder="Filter by Failure Reason"
        options={failureReasonOptions}
        size="middle"
        onChange={handleFailureReasonFilter}
        value={filters.failureReason}
        allowClear
      />
      <Select
        placeholder="Filter by Sort"
        options={sortOptions}
        size="middle"
        onChange={handleSortFilter}
        value={filters.sort}
        allowClear
      />
      <Button
        type="default"
        size="middle"
        icon={<ClearOutlined />}
        onClick={clearFilters}
      >
        Clear All
      </Button>

      <Button
        type="primary"
        icon={<UploadOutlined />}
        size="middle"
        onClick={handleFileUploadClick}
      >
        Upload File
      </Button>
    </div>
  );
};

export default FileUploadsFilterMenu;
